class BottomBarMenuComponent extends Component
{

    component_interface;

    constructor() {
        super(BottomBarMenuComponent, '.bottom_bar_menu_component');
        this.component_interface = new BottomBarMenuInterface();
        this.registerListeners();


    }



    registerListeners() {
        super.registerListeners();

        let go_back_button_listener = new BottomBarMenuGoBackButtonListener(
            this.component_interface.selectors.getGoBackButtonSelector(),
            this.component_interface
        );

        let payments_button_listener = new BottomBarMenuPaymentsButtonListener(
            this.component_interface.selectors.getBookingPaymentsLinkSelector(),
            this.component_interface
        );

        let context = this;
        $(document).on('click', 'button, a', function (e){
            context.afterDocumentChangedEvent();
        });
    }




    afterDocumentChangedEvent() {
        super.afterDocumentChangedEvent();

        if($('.passengers_panel').length == 0)
        {
            $(this.component_interface.selectors.getAddPassengerButtonSelector()).addClass('pulse-circle');
        }
        else
        {
            $(this.component_interface.selectors.getAddPassengerButtonSelector()).removeClass('pulse-circle');
        }

        if(window.location.href.includes('auth-search'))
        {
            if($('.minified_booking_ride_panel').length > 0 && !$('#append_rides').hasClass('hide') && !$('#ride_search_collapse').hasClass('in'))
            {
                $(this.component_interface.selectors.getGoBackButtonSelector()).closest('.round-button').removeClass('hide');
            }
            else
            {
                $(this.component_interface.selectors.getGoBackButtonSelector()).closest('.round-button').addClass('hide');
            }
        }


    }

}

$(document).ready(function (e){
    Components.addComponent(
        new BottomBarMenuComponent()
    );
});

